var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9B9B9B",
    d: "M28.416 27.527c-.878-.865-1.896-1.414-2.709-1.903-.722-.435-1.301-.844-1.681-1.356-.346-.465-.561-1.076-.602-2.045 1.45-2.117 2.105-4.981 2.105-7.605 0-1.768-.546-3.455-1.66-4.688-1.108-1.228-2.768-1.947-4.744-1.93-1.999-.017-3.659.702-4.768 1.93-1.113 1.233-1.66 2.92-1.66 4.688 0 2.624.655 5.488 2.106 7.605-.042.97-.256 1.58-.602 2.045-.38.512-.96.921-1.682 1.356-1.183.712-2.802 1.55-3.787 3.308-.2.41-.379.854-.563 1.296-.046.357-.099.713-.169 1.067a16.227 16.227 0 0 0 1.74 1.513c.001-.77.197-1.541.63-2.26.575-1.602 1.764-2.135 3.23-3.017.404-.244.826-.51 1.231-.832a5.865 5.865 0 0 0 1.063-1.087c.665-.893 1.08-2.107 1.08-3.641 0-.251-.082-.494-.233-.69-1.189-1.532-1.905-4.284-1.905-6.663 0-1.306.39-2.417 1.08-3.182.692-.766 1.698-1.248 3.186-1.23 1.51-.018 2.517.464 3.208 1.23.692.765 1.08 1.876 1.08 3.182 0 2.379-.716 5.13-1.904 6.663a1.124 1.124 0 0 0-.234.69c0 1.534.416 2.748 1.08 3.641.665.894 1.512 1.448 2.295 1.919 1.466.882 2.654 1.415 3.253 2.998.268.777.333 1.632.343 2.471A15.94 15.94 0 0 0 30 31.515c-.092-1.29-.676-2.597-1.39-3.635a1.978 1.978 0 0 1-.194-.353z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    stroke: "#979797",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.bc9aa23a838e7c58a18025ac74863bb8.svg";
export { ForwardRef as ReactComponent };